import { Container, ErrorBoundary, Head } from "@/components"
import { Sidebar } from "@/components/Category/Sidebar"
import { SliceRender } from "@/components/Category/Slice"
import { useLayout } from "@/lib/preFetch/preFetchLayout"
import { CategoryDocument, CategoryNavDocument } from "@/lib/prismicio/types.generated"
import { useTextConversionMethod } from "@/lib/prismicio/useTextConversion"
import { asText, isFilled } from "@prismicio/helpers"
import { lowerCase, upperFirst } from "lodash-es"
import type { CSSProperties } from "react"

interface CategoryProperties extends CSSProperties {
    ["--category-nav-hover-color"]: string
}
export const Category = ({
    title,
    prismic,
    paths,
}: {
    title: string
    prismic: CategoryDocument["data"]
    paths: { locale: string; url: string }[]
}) => {
    const textConvert = useTextConversionMethod()
    const titleFromCt = textConvert(upperFirst(lowerCase(title)))
    const titleFromPrismic = textConvert(asText(prismic.meta_tag_title))
    const nav = isFilled.contentRelationship<"category_nav", string, CategoryNavDocument["data"]>(prismic.category_nav)
        ? prismic.category_nav
        : null
    const { layout } = useLayout()
    const style: CategoryProperties = {
        "--category-nav-hover-color": layout.categoryNavHover.color,
    }
    const metaTitle = titleFromPrismic || titleFromCt ? `${titleFromCt} | GARCIA` : "GARCIA"
    return (
        <ErrorBoundary>
            <Head
                og={{ title: metaTitle, description: asText(prismic.meta_tag_description) }}
                title={metaTitle}
                robots={asText(prismic.meta_tag_robots)}
                description={asText(prismic.meta_tag_description)}
                alternate={paths}
            />
            <Container>
                <div className="grid grid-cols-12 gap-x-4 lg:pt-2.5" style={style}>
                    <div className="col-span-2 hidden w-full lg:block">{nav && <Sidebar nav={nav.data} />}</div>
                    <div className="col-span-12 w-full lg:col-span-10">
                        {prismic.body.length ? <SliceRender slices={prismic.body} /> : null}
                    </div>
                </div>
            </Container>
        </ErrorBoundary>
    )
}
